<template>
  <div class="container invoice-table">
    <br>
    <h5>Продажи
      <button v-if="isReportDownloadEnabled" class="btn btn-outline-primary btn-download"
              v-bind:class="isReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
              @click="downloadReport"
              :disabled="isReportDisabled">
        <span v-if="!isReportDisabled">Годовой отчет</span>
        <span v-if="isReportDisabled" class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true">
                </span>
      </button>
    </h5>
    <div class="container">
      <div class="row">
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="year"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Год"
                    aria-describedby="basic-addon2">
              <option v-for="item in years" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="month"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Месяц"
                    aria-describedby="basic-addon2">
              <option v-for="item in months" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 150px">
            <select v-model="landCountryID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Страна"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.landCountries" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 150px">
            <select v-model="paymentTypeID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Оплата"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.paymentTypes" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto" style="margin-top: 8px">
          <input type="checkbox" v-model="tasksIt"
                 @change="switchCountry"
                 id="tasksIt"
                 name="tasksIt">&nbsp;ИТ
        </div>
        <div class="col-sm-auto" style="margin-top: 8px">
          <input type="checkbox" v-model="tasksMaintenance"
                 @change="switchCountry"
                 id="tasksMaintenance"
                 name="tasksMaintenance">&nbsp;Эксплуатация
        </div>
        <div class="col-sm-auto" style="margin-top: 8px">
          <input type="checkbox" v-model="tasksCleaning"
                 @change="switchCountry"
                 id="tasksCleaning"
                 name="tasksCleaning">&nbsp;Клининг
        </div>
        <div class="col-sm-auto" style="margin-top: 8px">
          <input type="checkbox" v-model="tasksB2B2C"
                 @change="switchCountry"
                 id="tasksB2B2C"
                 name="tasksB2B2C">&nbsp;B2B2C
        </div>
        <!--        <div class="col-sm-auto" style="margin-top: 8px">-->
        <!--          <input type="checkbox" v-model="subscription"-->
        <!--                 @change="switchCountry"-->
        <!--                 id="subscription"-->
        <!--                 name="tasksB2B2C">&nbsp;Подписка-->
        <!--        </div>-->
        <div class="col-sm-auto" style="margin-top: 8px">
          <input type="checkbox" v-model="marginNominal"
                 @change="switchCountry"
                 id="subscription"
                 name="tasksB2B2C">&nbsp;Маржа Н.
        </div>
      </div>
    </div>


    <div>
      <table class="table table-sm text-left">
        <thead>
        <th class="manager-td-width"></th>
        <th class="text-right invoice-table-td-small">Задания</th>
        <th class="text-right invoice-table-td-small">Магазины</th>
        <th class="text-right invoice-table-td-small">Скорость</th>
        <th class="text-right invoice-table-td-small">Вовремя</th>
        <th class="text-right invoice-table-td-medium">План</th>
        <th class="text-right invoice-table-td-medium">Услуги</th>
        <th class="text-right invoice-table-td-small">План,%</th>
        <th v-if="isCurrentMonth" class="text-right invoice-table-td-small">Прогноз,%</th>
        <th class="text-right invoice-table-td-medium">Оборот</th>
        <!--                                <th class="text-right invoice-table-td-medium">На задание</th>-->
        <!--                                <th class="text-right invoice-table-td-medium">На магазин</th>-->
        <th class="text-right invoice-table-td-medium text-nowrap">Маржа</th>
        <th class="text-right invoice-table-td-small text-nowrap">Маржа,%</th>
        <th v-if="marginNominal" class="text-right invoice-table-td-medium text-nowrap">Маржа Н</th>
        <th v-if="marginNominal" class="text-right invoice-table-td-small text-nowrap">Маржа Н,%</th>
        <th class="text-right invoice-table-td-medium">Услуги исп.</th>
        <th class="text-right invoice-table-td-medium">Расходники (закуп.)</th>
        </thead>
        <tbody>
        <template v-for="(m, m_idx) in planManager">
          <tr>
            <td @click="showManagerChildren(m.item_id, m_idx)" class="cursor-pointer text-nowrap">{{
                m.item_name
              }}
            </td>
            <td class="text-right">{{ m.tasks_count }}</td>
            <td class="text-right">{{ m.shops_count }}</td>
            <td class="text-right">{{ Math.round(m.tasks_close_speed * 10) / 10 }}</td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru', {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(m.on_time_completion_rate/100)
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_customer_services_plan))
              }}
            </td>
            <td class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_customer_services))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru', {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(m.plan_percent)
              }}
            </td>
            <td v-if="isCurrentMonth" class="text-right">{{
                new
                Intl.NumberFormat('ru-ru', {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(m.plan_percent_forecast)
              }}
            </td>
            <td class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_customer))
              }}
            </td>
            <!--                        <td></td>-->
            <!--                        <td></td>-->
            <td class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.margin_sum))
              }}
            </td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru', {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(m.margin_percent)
              }}
            </td>
            <td v-if="marginNominal" class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.margin_sum_nominal))
              }}
            </td>
            <td v-if="marginNominal" class="text-right">{{
                new
                Intl.NumberFormat('ru-ru', {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(m.margin_percent_nominal)
              }}
            </td>
            <td class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_contractor_services))
              }}
            </td>
            <td class="text-right"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_contractor_parts + m.sum_cashless_parts))
              }}
            </td>
          </tr>
          <template v-if="m.show_children" v-for="(customer, customer_idx) in m.items">
            <tr class="invoice-table-tr-height">
              <td @click="showCustomerChildren(customer.item_id, m_idx, customer_idx)"
                  class="cursor-pointer vertical-align-middle td-padding-left-1">{{ customer.item_name }}
              </td>
              <td class="text-right vertical-align-middle" v-bind:title="'В: ' + customer.tasks_count + '\n' +
                            'Н: ' + customer.tasks_count_in_new + '\n' +
                            'Р: ' + customer.tasks_count_in_work + '\n' +
                            'П: ' + customer.tasks_count_on_approval"> {{ customer.tasks_count }}
              </td>
              <td class="text-right vertical-align-middle"> {{ customer.shops_count }}
              </td>
              <td class="text-right vertical-align-middle">
                {{ Math.round(customer.tasks_close_speed * 10) / 10 }}
              </td>
              <td class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(customer.on_time_completion_rate/100)
                }}
              </td>
              <td class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services_plan))
                }}
              </td>
              <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_in_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_on_approval)))">
                {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services))
                }}
              </td>
              <td class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(customer.plan_percent)
                }}
              </td>
              <td v-if="isCurrentMonth" class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(customer.plan_percent_forecast)
                }}
              </td>
              <td class="text-right vertical-align-middle"> {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer))
                }}
              </td>
              <!--                        <td></td>-->
              <!--                        <td></td>-->
              <td class="text-right vertical-align-middle"> {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.margin_sum))
                }}
              </td>
              <td class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(customer.margin_percent)
                }}
              </td>
              <td v-if="marginNominal" class="text-right vertical-align-middle"> {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.margin_sum_nominal))
                }}
              </td>
              <td v-if="marginNominal" class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  }).format(customer.margin_percent_nominal)
                }}
              </td>
              <td class="text-right vertical-align-middle"> {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_contractor_services))
                }}
              </td>
              <td class="text-right vertical-align-middle"> {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_contractor_parts + customer.sum_cashless_parts))
                }}
              </td>
            </tr>
            <template v-if="customer.show_children" v-for="(department, department_idx) in customer.items">
              <tr class="invoice-table-tr-height">
                <td @click="showDepartmentChildren(department.item_id, m_idx, customer_idx, department_idx)"
                    class="cursor-pointer vertical-align-middle td-padding-left-2">{{
                    department.item_name
                  }}
                </td>
                <td class="text-right vertical-align-middle" v-bind:title="'В: ' + department.tasks_count + '\n' +
                            'Н: ' + department.tasks_count_in_new + '\n' +
                            'Р: ' + department.tasks_count_in_work + '\n' +
                            'П: ' + department.tasks_count_on_approval"> {{ department.tasks_count }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    department.shops_count
                  }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    Math.round(department.tasks_close_speed * 10) / 10
                  }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru', {
                      style: 'percent',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(department.on_time_completion_rate/100)
                  }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services_plan))
                  }}
                </td>
                <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_in_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_on_approval)))">
                  {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services))
                  }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru', {
                      style: 'percent',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(department.plan_percent)
                  }}
                </td>
                <td v-if="isCurrentMonth" class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru', {
                      style: 'percent',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(department.plan_percent_forecast)
                  }}
                </td>
                <td class="text-right vertical-align-middle"> {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer))
                  }}
                </td>
                <!--                        <td></td>-->
                <!--                        <td></td>-->
                <td class="text-right vertical-align-middle"> {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.margin_sum))
                  }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru', {
                      style: 'percent',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(department.margin_percent)
                  }}
                </td>
                <td v-if="marginNominal" class="text-right vertical-align-middle"> {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.margin_sum_nominal))
                  }}
                </td>
                <td v-if="marginNominal" class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru', {
                      style: 'percent',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    }).format(department.margin_percent_nominal)
                  }}
                </td>
                <td class="text-right vertical-align-middle"> {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_contractor_services))
                  }}
                </td>
                <td class="text-right vertical-align-middle"> {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_contractor_parts + department.sum_cashless_parts))
                  }}
                </td>
              </tr>
              <template v-if="department.show_children" v-for="(branch, branch_idx) in department.items">
                <tr class="invoice-table-tr-height">
                  <td @click="showBranchChildren(branch.item_id, m_idx, customer_idx, department_idx, branch_idx)"
                      class="cursor-pointer vertical-align-middle td-padding-left-3">{{
                      branch.item_name
                    }}
                  </td>
                  <td class="text-right vertical-align-middle" v-bind:title="'В: ' + branch.tasks_count + '\n' +
                            'Н: ' + branch.tasks_count_in_new + '\n' +
                            'Р: ' + branch.tasks_count_in_work + '\n' +
                            'П: ' + branch.tasks_count_on_approval"> {{ branch.tasks_count }}
                  </td>
                  <td class="text-right vertical-align-middle"> {{ branch.shops_count }}
                  </td>
                  <td class="text-right vertical-align-middle">{{
                      Math.round(branch.tasks_close_speed * 10) / 10
                    }}
                  </td>
                  <td class="text-right vertical-align-middle">{{
                      new
                      Intl.NumberFormat('ru-ru', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      }).format(branch.on_time_completion_rate/100)
                    }}
                  </td>
                  <td class="text-right vertical-align-middle">
                    <div v-if="!branch.editable || !branch.active" @click="branch.editable = true"
                         class="cursor-pointer">
                      <div> {{
                          new
                          Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services_plan))
                        }}
                      </div>
                    </div>
                    <div v-if="branch.editable && branch.active">
                      <input v-model="branch.sum_customer_services_plan"
                             @change="savePlan(m_idx, customer_idx, department_idx, branch_idx, branch.sum_customer_services_plan)"
                             @blur="savePlan(m_idx, customer_idx, department_idx, branch_idx, branch.sum_customer_services_plan)"
                             type="number" class="text-right table-td-input no-spin"/>
                    </div>
                  </td>
                  <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_in_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_on_approval)))">
                    {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services))
                    }}
                  </td>
                  <td class="text-right vertical-align-middle">{{
                      new
                      Intl.NumberFormat('ru-ru', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      }).format(branch.plan_percent)
                    }}
                  </td>
                  <td v-if="isCurrentMonth" class="text-right vertical-align-middle">{{
                      new
                      Intl.NumberFormat('ru-ru', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      }).format(branch.plan_percent_forecast)
                    }}
                  </td>
                  <td class="text-right vertical-align-middle"> {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer))
                    }}
                  </td>
                  <!--                        <td></td>-->
                  <!--                        <td></td>-->
                  <td class="text-right vertical-align-middle"> {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.margin_sum))
                    }}
                  </td>
                  <td class="text-right vertical-align-middle">{{
                      new
                      Intl.NumberFormat('ru-ru', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      }).format(branch.margin_percent)
                    }}
                  </td>
                  <td v-if="marginNominal" class="text-right vertical-align-middle"> {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.margin_sum_nominal))
                    }}
                  </td>
                  <td v-if="marginNominal" class="text-right vertical-align-middle">{{
                      new
                      Intl.NumberFormat('ru-ru', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      }).format(branch.margin_percent_nominal)
                    }}
                  </td>
                  <td class="text-right vertical-align-middle"> {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_contractor_services))
                    }}
                  </td>
                  <td class="text-right vertical-align-middle"> {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_contractor_parts + branch.sum_cashless_parts))
                    }}
                  </td>
                </tr>
                <template v-if="branch.show_children" v-for="history in branch.items">
                  <tr>
                    <td class="td-padding-left-4 text-nowrap vertical-align-middle">{{ history.period }}</td>
                    <td class="text-right vertical-align-middle">{{ history.tasks_count }}</td>
                    <td class="text-right vertical-align-middle">{{ history.shops_count }}</td>
                    <td class="text-right vertical-align-middle">{{
                        Math.round(history.tasks_close_speed * 10) / 10
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.on_time_completion_rate/100)
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer_services_plan))
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer_services))
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.plan_percent)
                      }}
                    </td>
                    <td v-if="isCurrentMonth" class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.plan_percent_forecast)
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer))
                      }}
                    </td>
                    <!--                                <td class="text-right">{{ new-->
                    <!--                                    Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer/history.tasks_count))-->
                    <!--                                    }}-->
                    <!--                                </td>-->
                    <!--                                <td class="text-right">{{ new-->
                    <!--                                    Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer/history.shops_count))-->
                    <!--                                    }}-->
                    <!--                                </td>-->
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.margin_sum))
                      }}
                    </td>
                    <td class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.margin_percent)
                      }}
                    </td>
                    <td v-if="marginNominal" class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.margin_sum_nominal))
                      }}
                    </td>
                    <td v-if="marginNominal" class="text-right vertical-align-middle">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.margin_percent_nominal)
                      }}
                    </td>

                    <td class="text-right vertical-align-middle"> {{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_contractor_services))
                      }}
                    </td>
                    <td class="text-right vertical-align-middle"> {{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_contractor_parts + history.sum_cashless_parts))
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>

        </template>
        <tr>
          <td></td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalTasksCount))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalShopsCount))
            }}
          </td>
          <td></td>
          <td></td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalPlan))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalSales))
            }}
          </td>
          <td class="text-right">{{
              new
              Intl.NumberFormat('ru-ru', {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(this.totalSales / this.totalPlan)
            }}
          </td>
          <td v-if="isCurrentMonth" class="text-right">{{
              new
              Intl.NumberFormat('ru-ru', {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(this.totalSalesForecast / this.totalPlan)
            }}
          </td>
          <!--                    <td></td>-->
          <!--                    <td></td>-->
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalSalesCustomer))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalMargin))
            }}
          </td>
          <td class="text-right">{{
              new
              Intl.NumberFormat('ru-ru', {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(this.totalMargin / this.totalSalesCustomer)
            }}
          </td>
          <td v-if="marginNominal" class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalMarginNominal))
            }}
          </td>
          <td v-if="marginNominal" class="text-right">{{
              new
              Intl.NumberFormat('ru-ru', {
                style: 'percent',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(this.totalMarginNominal / this.totalSalesCustomer)
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalContractorServices))
            }}
          </td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalContractorParts + this.totalCashlessParts))
            }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

let usd_to_rub_rate = 90;

var d = new Date();

var this_year = d.getFullYear();
var this_month = d.getMonth();

this_month = this_month + 1;


export default {
  name: 'Sales',
  data() {
    return {
      years: [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: this_year,
      month: this_month,
      tasksIt: true,
      tasksMaintenance: true,
      tasksCleaning: true,
      tasksB2B2C: true,
      subscription: true,
      marginNominal: false,
      countryID: "Russia",
      planManager: [],
      paymentTypeID: 0,
      isReportDownloadEnabled: true,
      isReportError: false,
      reportDisabled: false,
    }
  },

  computed: {
    isReportDisabled() {
      return this.reportDisabled;
    },
    totalTasksCount: function () {
      return this.planManager ? this.planManager.map(el => el.tasks_count).reduce((a, b) => a + b, 0) : 0;
    },
    totalShopsCount: function () {
      return this.planManager ? this.planManager.map(el => el.shops_count).reduce((a, b) => a + b, 0) : 0;
    },
    totalPlan: function () {
      return this.planManager ? this.planManager.map(el => el.sum_customer_services_plan).reduce((a, b) => a + b, 0) : 0;
    },
    totalSales: function () {
      return this.planManager ? this.planManager.map(el => el.sum_customer_services).reduce((a, b) => a + b, 0) : 0;
    },
    totalSalesForecast: function () {
      return this.planManager ? this.planManager.map(el => el.sum_customer_services_forecast).reduce((a, b) => a + b, 0) : 0;
    },
    totalSalesCustomer: function () {
      return this.planManager ? this.planManager.map(el => el.sum_customer).reduce((a, b) => a + b, 0) : 0;
    },
    totalMargin: function () {
      return this.planManager ? this.planManager.map(el => el.margin_sum).reduce((a, b) => a + b, 0) : 0;
    },
    totalMarginNominal: function () {
      return this.planManager ? this.planManager.map(el => el.margin_sum_nominal).reduce((a, b) => a + b, 0) : 0;
    },
    totalContractorParts: function () {
      return this.planManager ? this.planManager.map(el => el.sum_contractor_parts).reduce((a, b) => a + b, 0) : 0;
    },
    totalContractorServices: function () {
      return this.planManager ? this.planManager.map(el => el.sum_contractor_services).reduce((a, b) => a + b, 0) : 0;
    },
    totalCashlessParts: function () {
      return this.planManager ? this.planManager.map(el => el.sum_cashless_parts).reduce((a, b) => a + b, 0) : 0;
    },
    isCurrentMonth: function () {
      return this.year == this_year && this.month == this_month
    },
  },

  methods: {
    search() {
      axios.get('/sales_plan', {
        params: {
          year: this.year,
          month: this.month,
          tasksIt: this.tasksIt,
          tasksMaintenance: this.tasksMaintenance,
          tasksB2B2C: this.tasksB2B2C,
          tasksCleaning: this.tasksCleaning,
          withSubscription: this.subscription,
          land_country_id: this.landCountryID,
          paymentTypeID: this.paymentTypeID,
        },
      })
          .then((res) => {
            // console.log(res.data);

            this.planManager = [];

            res.data.forEach(function (element) {
              element.show_children = false;
              element.items = [];

              if (element.department_id == 1325) {

              }

              if (element.sum_customer_services_plan > 0) {
                element.plan_percent = element.sum_customer_services / element.sum_customer_services_plan
              }
              if (element.sum_customer_services_plan > 0) {
                element.plan_percent_forecast = element.sum_customer_services_forecast / element.sum_customer_services_plan
              }
              if (element.sum_customer > 0) {
                element.margin_percent = element.margin_sum / element.sum_customer
              }
              if (element.tasks_close_speed > 1000) {
                element.tasks_close_speed = 0
              }
            });
            this.planManager = res.data;

          })
          .catch(error => console.log(`Error: ${error}`));
    },

    downloadReport() {
      this.reportDisabled = true;
      this.isReportError = false;
      axios.get(`/report/sales_by_year_report`, {
        responseType: 'blob', params: {
          year: this.year,
          land_country_id: this.landCountryID,
        },
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `sales_report_${this.landCountryID}_${this.year}.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isReportError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.reportDisabled = false;
          });
    },

    showManagerChildren(managerId, m_idx) {

      if (this.planManager[m_idx].show_children === false) {
        this.planManager[m_idx].show_children = true;

        axios.get('/sales_plan_manager', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: managerId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
                element.editable = false;

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent = element.sum_customer_services / element.sum_customer_services_plan
                }

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent_forecast = element.sum_customer_services_forecast / element.sum_customer_services_plan
                }

                if (element.sum_customer > 0) {
                  element.margin_percent = element.margin_sum / element.sum_customer
                }

                if (element.tasks_close_speed > 1000) {
                  element.tasks_close_speed = 0
                }

                // if (this_year === d.getFullYear() && (this_month === d.getMonth() + 1)) {
                //     console.log(d.getFullYear());
                //     console.log(this_year);
                //     console.log(d.getMonth() + 1);
                //     console.log(this_month);
                //     //element.active = true;
                // }

              });

              this.planManager[m_idx].items = res.data;


              this.planManager[m_idx].sum_customer_services_plan = 0;
              this.planManager[m_idx].items.forEach(el => {
                this.planManager[m_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
              });

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].show_children = false;
      }
    },
    showCustomerChildren(customerId, m_idx, customer_idx) {

      if (this.planManager[m_idx].items[customer_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].show_children = true;

        axios.get('/sales_plan_customer', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            land_country_id: this.landCountryID,
            manager_id: this.planManager[m_idx].item_id,
            paymentTypeID: this.paymentTypeID,
            customer_id: customerId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent = element.sum_customer_services / element.sum_customer_services_plan
                }

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent_forecast = element.sum_customer_services_forecast / element.sum_customer_services_plan
                }

                if (element.sum_customer > 0) {
                  element.margin_percent = element.margin_sum / element.sum_customer
                }

                if (element.tasks_close_speed > 1000) {
                  element.tasks_close_speed = 0
                }
              });

              this.planManager[m_idx].items[customer_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].show_children = false;
      }
    },

    showDepartmentChildren(departmentId, m_idx, customer_idx, department_idx) {

      if (this.planManager[m_idx].items[customer_idx].items[department_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].items[department_idx].show_children = true;

        axios.get('/sales_plan_department', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: this.planManager[m_idx].item_id,
            department_id: departmentId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
                element.editable = false;
                element.active = false;
                // element.active = true;

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent = element.sum_customer_services / element.sum_customer_services_plan
                }

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent_forecast = element.sum_customer_services_forecast / element.sum_customer_services_plan
                }

                if (element.sum_customer > 0) {
                  element.margin_percent = element.margin_sum / element.sum_customer
                }

                if (element.tasks_close_speed > 1000) {
                  element.tasks_close_speed = 0
                }

              });

              this.planManager[m_idx].items[customer_idx].items[department_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].items[department_idx].show_children = false;
      }
    },

    showBranchChildren(branchId, m_idx, customer_idx, department_idx, branch_idx) {

      if (this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children = true;

        axios.get('/sales_plan_branch', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: this.planManager[m_idx].item_id,
            department_id: this.planManager[m_idx].items[customer_idx].items[department_idx].item_id,
            branch_id: branchId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];

                if (element.sum_customer_services_plan > 0) {
                  element.plan_percent = element.sum_customer_services / element.sum_customer_services_plan
                }

                if (element.tasks_close_speed > 1000) {
                  element.tasks_close_speed = 0
                }

              });

              this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children = false;
      }
    },

    savePlan(m_idx, customer_idx, department_idx, branch_idx, plan) {

      this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].editable = false;

      axios.post('/sales_plan', {
        year: this.year,
        month: this.month,
        land_country_id: this.landCountryID,
        customer_id: this.planManager[m_idx].items[customer_idx].item_id,
        department_id: this.planManager[m_idx].items[customer_idx].items[department_idx].item_id,
        branch_id: this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].item_id,
        sum_customer_services: parseFloat(plan),
      })
          .then((res) => {
            // console.log(res.data);

            // res.data.forEach(function (element) {
            //     element.show_children = false;
            //     element.items = [];
            // });
            //
            // this.planManager[m_idx].items[customer_idx].items = res.data;

          })
          .catch(error => console.log(`Error: ${error}`));

      this.planManager[m_idx].items[customer_idx].items[department_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items[customer_idx].items[department_idx].items.forEach(el => {
        this.planManager[m_idx].items[customer_idx].items[department_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });


      this.planManager[m_idx].items[customer_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items[customer_idx].items.forEach(el => {
        this.planManager[m_idx].items[customer_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });

      this.planManager[m_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items.forEach(el => {
        this.planManager[m_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });

    },

    switchCountry() {
      let landCountry = this.$store.getters.landCountries.find(({id}) => id === this.landCountryID);

      localStorage.setItem('landCountryID', this.landCountryID);
      localStorage.setItem('year', this.year);
      localStorage.setItem('month', this.month);
      localStorage.setItem('paymentTypeID', this.paymentTypeID);

      this.search();
    }

  },


  beforeCreate() {
    axios.defaults.headers.authorization = this.$store.state.token;
  }
  ,

  created() {

    document.title = 'Продажи';

    // let countryId = localStorage.getItem('countryId');
    // if (countryId != null) {
    //   this.countryId = countryId
    // } else {
    //   this.countryId = "ru";
    //   localStorage.setItem('countryId', this.countryId);
    // }

    let landCountryID = localStorage.getItem('landCountryID');
    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "Russia";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    let d = new Date();

    let year = localStorage.getItem('year');
    if (year != null) {
      this.year = year
    } else {
      this.year = d.getFullYear();
      localStorage.setItem('year', this.year);
    }

    let month = localStorage.getItem('month');
    if (month != null) {
      this.month = month
    } else {
      this.month = d.getMonth() + 1;
      localStorage.setItem('month', this.month);
    }

    let paymentTypeID = localStorage.getItem('paymentTypeID');
    if (paymentTypeID != null) {
      this.paymentTypeID = paymentTypeID
    } else {
      this.paymentTypeID = 0;
      localStorage.setItem('paymentTypeID', this.paymentTypeID);
    }

    this.search();
  }
  ,

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
}

.invoice-table-td-medium {
  width: 95px;
}

.invoice-table-td-small {
  width: 60px;
}

.table-td-input {
  width: 70px;
}

.invoice-table-tr-height {
  vertical-align: middle;
  height: 36px;
}

.vertical-align-middle {
  vertical-align: middle;
}

.manager-td-width {
  width: 150px;
}

.td-padding-left-1 {
  padding-left: 40px;
}

.td-padding-left-2 {
  padding-left: 80px;
}

.td-padding-left-3 {
  padding-left: 120px;
}

.td-padding-left-4 {
  padding-left: 160px;
}

.no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  -moz-appearance: textfield !important;
}

</style>
